import authInstance from 'config/axios.config';

export const tourServices = {
  getTours: async (filters) => {
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== 'all' && value !== undefined && value !== null && value !== '') {
        params.append(key, String(value));
      }
    });

    const res = await authInstance.get(`/tour/admin?${params}`);
    return res.data;
  },

  getTourById: async (tourId) => {
    const res = await authInstance.get(`/tour/admin/${tourId}`);
    return res.data;
  },

  updateTour: async ({ tourId, data }) => {
    const res = await authInstance.patch(`/tour/admin/${tourId}`, data);
    return res.data;
  },

  deleteTour: async ({ tourId, hard = false }) => {
    const res = await authInstance.delete(`/tour/admin/${tourId}?hard=${hard}`);
    return res.data;
  },

  approveTour: async (tourId) => {
    const res = await authInstance.patch(`/tour/admin/${tourId}`, {
      approvalStatus: 'approved',
    });
    return res.data;
  },

  rejectTour: async ({ tourId, rejectionReason }) => {
    const res = await authInstance.patch(`/tour/admin/${tourId}`, {
      approvalStatus: 'rejected',
      rejectionReason,
    });
    return res.data;
  },

  toggleActiveStatus: async (tourId) => {
    const tour = await tourServices.getTourById(tourId);
    const res = await authInstance.patch(`/tour/admin/${tourId}`, {
      isActive: !tour.data.isActive,
    });
    return res.data;
  },

uploadVideo: async (file) => {

  const formData =
    new FormData();

  formData.append(
    'file',
    file
  );


  const res =
    await authInstance.post(

      '/admin/upload',

      formData,

      {
        headers:{

          'Content-Type':

          'multipart/form-data'

        }

      }

    );


  return res.data;
},

exportTours: async ({
  destination,
  tourType,
  category,
  approvalStatus,
  isActive,
  search,
  sortBy,
  sortOrder,
}) => {
  const params =
    new URLSearchParams({
      destination:
        destination || '',

      tourType:
        tourType === 'all'
          ? ''
          : tourType || '',

      category:
        category === 'all'
          ? ''
          : category || '',

      approvalStatus:
        approvalStatus === 'all'
          ? ''
          : approvalStatus || '',

      isActive:
        isActive === 'all'
          ? ''
          : isActive || '',

      search:
        search || '',

      sortBy:
        sortBy || 'createdAt',

      sortOrder:
        sortOrder || 'desc',
    });

  for (const [key, value] of [
    ...params.entries(),
  ]) {
    if (!value) {
      params.delete(key);
    }
  }

  return authInstance.get(
    `/tour/admin/export?${params.toString()}`,
    {
      responseType: 'blob',
    }
  );
},
};
